<nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '20px' }" [nzWidth]="1000" (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter" nzTitle="Task Activity History">
  <ng-container *nzModalContent>
    <div class="task-history-container">
      <!-- Old code commented out for reference -->
      <!--
      <nz-timeline *ngIf="listOfHistory?.length > 0">
        <nz-timeline-item *ngFor="let history of listOfHistory">{{history.text}} on <strong> {{history.date |
            date:'medium' }} </strong> by <strong> {{history.by}} </strong></nz-timeline-item>
      </nz-timeline>
      <nz-result nzIcon="smile-twotone" nzTitle="No data found!" *ngIf="listOfHistory?.length == 0"></nz-result>
      -->

      <!-- new design starts  -->

      <div *ngIf="groupedHistory?.length > 0; else noData">
        <div *ngFor="let group of groupedHistory; let gIdx = index">
          <div class="history-date-group" (click)="group.expanded = !group.expanded"
            [attr.aria-expanded]="group.expanded">
            <div class="date-header">
              <span class="date-icon"><i nz-icon nzType="calendar" nzTheme="outline"></i></span>
              <span class="date-title">{{ group.displayDate }}</span>
              <span class="activity-count">{{ group.activities.length }} Activities</span>
              <span class="chevron">
                <i nz-icon [nzType]="group.expanded ? 'up' : 'down'" nzTheme="outline"></i>
              </span>
            </div>
          </div>
          <div class="history-activities" *ngIf="group.expanded">
            <div *ngFor="let item of group.activities; let idx = index" class="timeline-item"
              [class.timeline-last]="idx === group.activities.length - 1">
              <span class="timeline-dot" [ngClass]="getDotClass(item.type)">
                <!-- <i nz-icon [nzType]="getIconType(item.type)" nzTheme="fill"></i> -->
              </span>
              <span class="timeline-line" *ngIf="idx !== group.activities.length - 1"></span>
              <span class="timeline-time" style="margin-right: 8px;"><b>{{ formatTimelineTime(item.date) }}</b></span>
              <span class="timeline-details">
                <span class="timeline-action"
                  [innerHTML]="item.expandedText ? highlightStatusBold(item.text) : formatActivityText(item.text)"
                  (click)="toggleActivityExpand($event, item)" title="Click to expand/collapse">
                </span>
                <span class="timeline-user"> By {{ item.by }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noData>
        <nz-result nzIcon="smile-twotone" nzTitle="No data found!"></nz-result>
      </ng-template>

      <!-- new design ends  -->

    </div>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="handleOk()">OK</button>
  </ng-template>
</nz-modal>